import {loadMoreBtnWrapper} from "./loadMore";

let filterChanged;

const controlsSelector = '.filter-controls';
const contentSelector = '.filter-content';
const emptyContentSelector = '.filter-empty-content';

(() => {

    const controls = document.querySelector(controlsSelector);
    const clearBtn = document.querySelector(`${controlsSelector} + button`);
    const content = document.querySelector(contentSelector);
    const emptyContent = document.querySelector(emptyContentSelector);

    if (!controls || !clearBtn || !content || !emptyContent) {
        return;
    }

    const checkboxes = controls.querySelectorAll('input');
    const items = content.children;

    const showFilterItem = (el, force = false) => el.style.display = (force ? 'flex' : '');
    const hideFilterItem = (el) => el.style.display = 'none';

    /* --- ACTUALLY FILTER ITEMS --- */
    filterChanged = () => {
        const checkedBoxes = [...checkboxes]
            .filter((el) => el.checked)
            .map((item) => ({
                attribute: item.name,
                value: item.value,
            }));

        // No filtering -> allow all items to be shown, but keep those that
        // have not been "loaded" yet hidden
        if (checkedBoxes.length === 0) {
            [...items].forEach((el) => showFilterItem(el, false));
            clearBtn.classList.add('hidden');
            content.classList.remove('hidden');
            emptyContent.classList.add('hidden');
            loadMoreBtnWrapper.classList.remove('hidden');
            return;
        }

        const checkedOptions = {};
        checkedBoxes.forEach(({attribute, value}) => {
            checkedOptions[attribute] = [...(checkedOptions[attribute] ?? []), value];
        });

        const checkedOptionsArray = Object.entries(checkedOptions);
        let visibleItemCount = 0;

        // Filter items
        [...items].forEach((el) => {
            // Force show all items by default, incl. those that have
            // not been "loaded yet"
            showFilterItem(el, true);
            visibleItemCount += 1;

            // Loop attributes and their checked values
            checkedOptionsArray.every(([attribute, values]) => {
                // Item's value for this attribute is not checked in filtering checkboxes -> hide item
                if (!values.includes(el.getAttribute(`data-${attribute}`))) {
                    hideFilterItem(el);
                    visibleItemCount -= 1;
                    return false; // don't continue looping throught checkboxes anymore
                }
                return true;
            });
        });

        if (visibleItemCount > 0) {
            content.classList.remove('hidden');
            emptyContent.classList.add('hidden');
        } else {
            content.classList.add('hidden');
            emptyContent.classList.remove('hidden');
        }

        clearBtn.classList.remove('hidden');

        // Hide "Load more" button if filter is active
        loadMoreBtnWrapper.classList.add('hidden');
    };

    /* --- CLEAR FILTER --- */
    clearBtn.addEventListener('click', () => {
        checkboxes.forEach((el) => {
            el.checked = false;
        });

        filterChanged();
    });

    /* --- LISTEN TO CHECKED EVENT --- */
    checkboxes.forEach((el) => {
        el.addEventListener('input', () => {
            const checked = el.checked;
            const isAll = el.value === 'all';

            // Normal checkbox checked -> continue
            if (checked && !isAll) {
                filterChanged();
                return;
            }

            const parent = el.closest(".filter-controls > div");

            // Normal checkbox unchecked -> uncheck 'All' option as well
            if (!isAll) {
                const allSibling = parent.querySelector('input[value=all]');

                if (allSibling) {
                    allSibling.checked = false;
                }

                filterChanged();
                return;
            }

            // All checkbox (un)checked -> (un)check all siblings
            parent
                .querySelectorAll('input')
                .forEach((el) => el.checked = checked);

            filterChanged();
        });
    });
})();

export {
    filterChanged,
    controlsSelector,
    contentSelector,
    emptyContentSelector,
};
